import { Component, Input, DOCUMENT, inject } from '@angular/core';

@Component({
  selector: 'bepatient-my-account-item',
  templateUrl: './my-account-item.component.html',
  styleUrls: ['./my-account-item.component.scss'],
  standalone: false
})
export class MyAccountItemComponent {
  document = inject(DOCUMENT);

  @Input() icon: string;
  @Input() label: string;
  @Input() color: string;
  @Input() size: string;
  @Input() type: string;
}
